module.exports = __webpack_public_path__ + "static/references_aero_spatial_auto_defense_EC3D-4dce4b8ed7bc9d5821939b8b953cc31e.jpg";